import { Helmet } from 'react-helmet-async';

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import HubIcon from '@mui/icons-material/Hub';

import { useFolderAccess } from '../../components/Access/hooks/useFolderAccess.hook';
import { SpeedDial } from '../../components/SpeedDial';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_FOLDERS_DEFAULT,
  PATH_FOLDER_COLLABORATIONS_NEW,
  PATH_FOLDER_DEFAULT,
  PATH_FOLDER_MISSIONS,
  PATH_FOLDER_MISSIONS_NEW,
} from '../../app/constants/paths.constant';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useFolderContext } from '../../contexts/FolderContext/hooks/useFolderContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { MissionsWithinAFolder } from './WithinAFolder';

export const FolderMissionsPage = () => {
  const { folderId, folder } = useFolderContext();

  const { paths } = useBuildPaths(
    {
      default: PATH_FOLDER_DEFAULT,
      missions: PATH_FOLDER_MISSIONS,
      newMission: PATH_FOLDER_MISSIONS_NEW,
      newCollaboration: PATH_FOLDER_COLLABORATIONS_NEW,
    },
    { folderId },
  );

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle('Liste des Missions du Dossier', folder?.code)}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_FOLDERS_DEFAULT,
            label: 'dossiers',
            key: 'folders',
          },
          {
            to: paths.default,
            label: 'dossier',
            key: 'folder',
          },
          {
            to: paths.missions,
            label: 'missions',
            key: 'missions',
          },
        ]}
      />
    </>
  );

  const titleContent = (
    <PageTitle
      code={folder?.code}
      title={folder?.consolidation.title ?? 'Liste des Missions du Dossier'}
    />
  );

  const access = useFolderAccess(folderId, folder);

  return (
    <>
      {beforeTitleContent}
      {titleContent}
      <MissionsWithinAFolder />
      <SpeedDial
        actions={[
          {
            id: 'createMission',
            gate: access.initMission,
            icon: <BusinessCenterIcon />,
            name: 'Créer Mission Simple',
            to: paths.newMission,
          },
          {
            id: 'createCollaboration',
            gate: access.initMission,
            icon: <HubIcon />,
            name: 'Créer Collaboration',
            to: paths.newCollaboration,
          },
        ]}
        title="Actions possibles sur les Missions"
      />
    </>
  );
};
